﻿import { useParams, useNavigate } from "react-router-dom";

import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";
import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";

import { base_object } from "../categories.constants";
import { useCategoryForm } from "../hooks/useCategoryForm";

const CategoryForm = ({ filters }) => {
	const navigate = useNavigate();
	const { option, slug } = useParams();

	const onClose = () => {
		setFormState({ ...base_object });
		setFormErrors({});
		navigate("/configuracion/categorias");
	};

	const {
		isOpen,
		modalTitle,
		isLoadingLookups,
		isLoadingSave,
		isLoadingElement,
		isFetchingElement,
		lookups,
		formState,
		setFormState,
		formErrors,
		setFormErrors,
		handleSubmit,
	} = useCategoryForm({
		option,
		filters,
		elementId: slug,
		baseObject: base_object,
		onClose,
	});

	if (!isOpen) return null;

	const isLoading = isLoadingLookups || isLoadingSave || isLoadingElement || isFetchingElement;

	const selectedEstateParentIds = Array.isArray(formState.estates_parents_ids) ? formState.estates_parents_ids : [];
	const filteredEstates =
		selectedEstateParentIds.length > 0
			? (lookups?.estates || []).filter((estate) => estate.estate_parent_id && selectedEstateParentIds.includes(estate.estate_parent_id))
			: [];

	return (
		<CustomModalForm open={isOpen} onClose={onClose} title={modalTitle} size="sm" asForm onSubmit={handleSubmit} isLoading={isLoading}>
			{isLoading ? (
				<CustomFetching center size="lg" />
			) : (
				<>
					<CustomInputText
						label="Nombre"
						name="name"
						value={formState.name}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, name: value }));
							setFormErrors((prev) => ({ ...prev, name: undefined }));
						}}
						placeholder="Ingrese el nombre"
						required
						col={12}
						error={formErrors.name}
					/>

					<CustomInputSelect
						label="Campos"
						name="estates_parents_ids"
						options={lookups?.estates_parents || []}
						value={formState.estates_parents_ids}
						onChange={(value) => {
							const selectedEstateParentIds = Array.isArray(value) ? value : [];
							const previousEstateParentIds = Array.isArray(formState.estates_parents_ids) ? formState.estates_parents_ids : [];

							const associatedEstates = (lookups?.estates || []).filter(
								(estate) => estate.estate_parent_id && selectedEstateParentIds.includes(estate.estate_parent_id),
							);

							const currentEstatesIds = Array.isArray(formState.estates_ids) ? formState.estates_ids : [];

							const removedEstateParentIds = previousEstateParentIds.filter((id) => !selectedEstateParentIds.includes(id));
							const estatesToRemove = (lookups?.estates || [])
								.filter((estate) => estate.estate_parent_id && removedEstateParentIds.includes(estate.estate_parent_id))
								.map((e) => e.value);

							const remainingEstatesIds = currentEstatesIds.filter((id) => !estatesToRemove.includes(id));
							const associatedEstateIds = associatedEstates.map((e) => e.value);
							const allEstatesIds = [...remainingEstatesIds, ...associatedEstateIds];
							const uniqueEstatesIds = [...new Set(allEstatesIds)];

							setFormState((prev) => ({
								...prev,
								estates_parents_ids: value,
								estates_ids: uniqueEstatesIds,
							}));
							setFormErrors((prev) => ({ ...prev, estates_parents_ids: undefined }));
						}}
						placeholder="Seleccione los campos"
						isMulti
						col={12}
						error={formErrors.estates_parents_ids}
					/>

					<CustomInputSelect
						label="Bodegas"
						name="estates_ids"
						options={filteredEstates}
						value={formState.estates_ids}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, estates_ids: value }));
							setFormErrors((prev) => ({ ...prev, estates_ids: undefined }));
						}}
						placeholder="Seleccione las bodegas"
						isMulti
						col={12}
						error={formErrors.estates_ids}
						isDisabled={selectedEstateParentIds.length === 0}
					/>
				</>
			)}
		</CustomModalForm>
	);
};

export default CategoryForm;
